import React from 'react'
import _ from 'lodash'
import { Typography, Divider } from '@material-ui/core'
import { useStyles } from './styles'

const COLOR_BY_DIMENSION = {
  'Ambiental':              '#6ca14d',
  'Ambiental IF':           '#78dea7',
  'Econômico-Financeira':   '#b284cf',
  'Geral':                  '#e866c3',
  'Governança Corporativa': '#439dd1',
  'Mudança do Clima':       '#f7d288',
  'Natureza do Produto':    '#ccb350',
  'Social':                 '#495f9c',
}

export default function SummaryPanel(props) {
  const classes = useStyles()

  const groupQuestionsBy = (questions, tagType) => {
    const comparisonFunction = question => question.tags.find(tag => tag.type === tagType).name
    const questionsGrouped = _.groupBy(questions, comparisonFunction)
    const typesSorted =
      [...new Set(Object.keys(questionsGrouped))]
        .sort((a, b) => {
          return Number(a.hierarchy) - Number(b.hierarchy)
        })

    return [questionsGrouped, typesSorted]
  }

  const [groupedByDimension, dimensions] =
    groupQuestionsBy(props.questions, 'dimension')

  const dimensionName = Object.keys(groupedByDimension)[0]

  const AnchorLinks = () => (
    <>
      {
        dimensions.map(dimension => {
          const [groupedByCriterion, criterions] =
            groupQuestionsBy(groupedByDimension[dimension], 'criterion')

          return criterions.map(criterion => {
            const [, indicators] =
              groupQuestionsBy(groupedByCriterion[criterion], 'indicator')

            return (
              <>
                <a className={ classes.criterionLink } href={ `#${ criterion }` }>
                  { criterion.split('–', 2)[0] }
                  { ' – ' }
                  <span style={{ color: COLOR_BY_DIMENSION[dimensionName] }}>{ criterion.split('–', 2)[1] }</span>
                </a>
                {
                  indicators.map(indicator => (
                    <a className={ classes.indicatorLink } href={ `#${indicator}` }>
                      { indicator.split('.', 2)[0] }
                      { '. ' }
                      <span style={{ color: COLOR_BY_DIMENSION[dimensionName] }}>{ indicator.split('.', 2)[1] }</span>
                    </a>
                  ))
                }
              </>
            )
          })
        })
      }
    </>
  )

  return (
    <>
      <div className={ classes.summaryHeader }>
        <Typography align="center" variant="h5">
          <strong>Questionário ISE B3 - Dimensão { dimensionName }</strong>
        </Typography>

        <Typography variant="h6">
          <strong>Sumário</strong>
        </Typography>
      </div>

      <AnchorLinks />

      <br />
      <Divider />
      <br />
    </>
  )
}
